import { render, staticRenderFns } from "./advertisement.vue?vue&type=template&id=c8d99d48&scoped=true"
import script from "./advertisement.vue?vue&type=script&lang=js"
export * from "./advertisement.vue?vue&type=script&lang=js"
import style0 from "./advertisement.vue?vue&type=style&index=0&id=c8d99d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d99d48",
  null
  
)

export default component.exports